import { z } from 'zod';
import { useEffect } from 'react';
import { createZodFormResolver, useFormControls, Validation } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { VERIFY_PASSWORD_FORM_ID } from './constants';

interface VerifyPasswordFormValues {
    password: string;
}

const resolver = createZodFormResolver<VerifyPasswordFormValues>(
    z.object({
        password: Validation.String.Required,
    })
);

export const useVerifyPasswordForm = (onSuccess: (password: string) => void) => {
    const { mutate, isPending, error } = useRepositoryMutation('users', 'verifyPassword', {
        meta: {
            disableDefaultErrorHandler: true,
        },
    });

    const handleSubmit = (values: VerifyPasswordFormValues) => {
        mutate(
            {
                password: values.password,
            },
            {
                onSuccess: () => onSuccess(values.password),
            }
        );
    };

    const { renderFormContent, setError, submit } = useFormControls<VerifyPasswordFormValues>({
        id: VERIFY_PASSWORD_FORM_ID,
        onSubmit: handleSubmit,
        resolver,
        defaultValues: { password: '' },
    });

    useEffect(() => {
        if (error) {
            setError('password', { message: (error as { message: string }).message });
        }
    }, [error, setError]);

    return { isLoading: isPending, submit, renderFormContent };
};
